/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Image from '../partials/Image';

import * as AppPropTypes from '../../lib/PropTypes';

import styles from '../../../styles/blocks/image.scss';

const propTypes = {
    image: AppPropTypes.image,
    imageUrl: PropTypes.string,
    imageCredit: PropTypes.string,
    imageNativeSize: PropTypes.bool,
    isLarge: PropTypes.bool,
    isLast: PropTypes.bool,
    className: PropTypes.string,
};

const defaultProps = {
    image: null,
    imageUrl: null,
    imageCredit: null,
    imageNativeSize: false,
    isLarge: false,
    isLast: false,
    className: null,
};

const ImageBlock = ({
    image,
    imageUrl,
    imageCredit,
    imageNativeSize,
    isLarge,
    isLast,
    className,
}) => {
    return (
        <div
            className={classNames({
                [styles.container]: true,
                [styles.isLarge]: isLarge,
                [styles.isLast]: isLast,
                [className]: className !== null,
            })}
        >
            {image !== null ? (
                <Image
                    {...image}
                    credits={imageCredit}
                    nativeSize={imageNativeSize}
                    imageUrl={imageUrl}
                />
            ) : null}
        </div>
    );
};

ImageBlock.propTypes = propTypes;
ImageBlock.defaultProps = defaultProps;

export default ImageBlock;
